import { jsx as _jsx } from "react/jsx-runtime";
import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { closeModalCalls, openModalCalls, setStatusMod } from "../../store/slices/callsSlice";
import styles from './Styles.module.scss';
import DialogComponent from "../Settings/DialogComponent";
import CallRoom from "./CallRoom";
import { messagesAPI } from "../../API/api";
const CallsListenerComponent = () => {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector(state => state.calls.isOpen);
    const myUid = useAppSelector(state => state.app.currentUser.uid);
    const callerUid = useAppSelector(state => state.calls.callerUid);
    const messageInfo = useAppSelector(state => state.calls.callInfo);
    const [isMinimized, setIsMinimized] = useState(false);
    const close = (click) => {
        setIsMinimized(false);
        dispatch(closeModalCalls(click));
    };
    const endCallFunc = (callDuration, status) => {
        if (messageInfo) {
            setTimeout(() => {
                messagesAPI.sendCallInfoMessage(Object.assign(Object.assign({}, messageInfo), { callDuration, status }));
            }, 2000);
        }
        close();
    };
    const startCallFunc = (mode) => {
        dispatch(setStatusMod(mode));
    };
    const toggleMinimize = (e) => {
        e.stopPropagation();
        setIsMinimized(prev => !prev);
    };
    useEffect(() => {
        const callRef = doc(db, 'calls', myUid);
        return onSnapshot(callRef, snapshot => {
            if (!snapshot.exists()) {
                close();
                return;
            }
            const data = snapshot.data();
            if ((data === null || data === void 0 ? void 0 : data.status) === 'incoming') {
                console.log(data);
                dispatch(openModalCalls({
                    mode: 'incoming',
                    callerUid: data.from,
                    roomId: data.roomId,
                }));
            }
        });
    }, [myUid]);
    return (_jsx("div", { className: styles.container, children: _jsx(DialogComponent, { isOpen: isOpen, onClose: () => close(true), isMinimized: isMinimized, children: _jsx(CallRoom, { myUid: myUid, calleeUid: callerUid, endCallFunc: endCallFunc, startCallFunc: startCallFunc, toggleMinimize: toggleMinimize, isMinimized: isMinimized }) }) }));
};
export default CallsListenerComponent;
